import React, { useContext, useEffect } from 'react'
import { Store } from '../../state/Provider'
import { Layout } from './Layout'
import { jsonRequest } from '../../api/jsonRequest'
import { useRouteParam } from '../../browser/useRouteParam'

export const TermsDeclined: React.FC = () => {
  const urlToken = useRouteParam('urlToken')
  useEffect(() => {
    jsonRequest('/api/sessions/1/truncate', { method: 'PUT' })
  }, [])

  const {
    state: { clinicName }
  } = useContext(Store)

  return <Layout clinicName={clinicName} urlToken={urlToken} />
}